var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 6C2 3.79086 3.79086 2 6 2H13C14.6569 2 16 3.34315 16 5V6C16 6.55228 15.5523 7 15 7C14.4477 7 14 6.55228 14 6V5C14 4.44772 13.5523 4 13 4H6C4.89543 4 4 4.89543 4 6V18.5C4 19.6046 4.89543 20.5 6 20.5H13C13.5523 20.5 14 20.0523 14 19.5V18C14 17.4477 14.4477 17 15 17C15.5523 17 16 17.4477 16 18V19.5C16 21.1569 14.6569 22.5 13 22.5H6C3.79086 22.5 2 20.7091 2 18.5V6ZM18.2929 8.29289C18.6834 7.90237 19.3166 7.90237 19.7071 8.29289L22.3536 10.9393C22.9393 11.5251 22.9393 12.4749 22.3536 13.0607L19.7071 15.7071C19.3166 16.0976 18.6834 16.0976 18.2929 15.7071C17.9024 15.3166 17.9024 14.6834 18.2929 14.2929L19.5858 13H10C9.44772 13 9 12.5523 9 12C9 11.4477 9.44772 11 10 11H19.5858L18.2929 9.70711C17.9024 9.31658 17.9024 8.68342 18.2929 8.29289Z",
    fill: "#292F4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLogout);
export default __webpack_public_path__ + "static/media/ic_logout.c8e94248bd1d9bd73225e56e70ed5e4b.svg";
export { ForwardRef as ReactComponent };